import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { telegramLogin } from '../store/features/authSlice';

const getInitData = () => window?.Telegram?.WebApp?.initData || '';

// Хук використовується в кількох компонентах (і StrictMode подвоює ефекти),
// тому логін виконуємо один раз на завантаження сторінки і ділимо результат.
let authPromise = null;
let authDone = false;

const runTelegramAuth = (dispatch) => {
  if (authPromise) return authPromise;

  authPromise = (async () => {
    const initData = getInitData();

    if (!initData) {
      // 🔹 Класичний браузер або відкрито не як Telegram mini app
      return;
    }

    // 🔥 Очищаємо старі токени перед новою авторизацією
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user');

    try {
      const result = await dispatch(telegramLogin(initData)).unwrap();

      // 🔹 Зберігаємо нові токени після логіну
      if (result?.access && result?.refresh) {
        localStorage.setItem('access', result.access);
        localStorage.setItem('refresh', result.refresh);
        localStorage.setItem('user', JSON.stringify(result.user));
      }
    } catch (err) {
      console.error('Telegram auth failed', err);
    }
  })().finally(() => {
    authDone = true;
  });

  return authPromise;
};

const useTelegramAuth = () => {
  const dispatch = useDispatch();

  const [isAuthReady, setIsAuthReady] = useState(authDone);
  const isTelegram = !!getInitData();

  useEffect(() => {
    let active = true;

    runTelegramAuth(dispatch).then(() => {
      if (active) setIsAuthReady(true);
    });

    return () => {
      active = false;
    };
  }, [dispatch]);

  return { isAuthReady, isTelegram };
};

export default useTelegramAuth;
